import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import CitySelection from '@r1-frontend/ui-react/components/popups/citySelection';

export const StyledCitySelection = styled(CitySelection)`
    position: relative;
    pointer-events: auto;
    z-index: 100;
    top: 0;
`;

export const CityConfirmationBlock = styled.div`
    position: absolute;
    right: 0;
    top: 0;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        top: 62px;
    }
    @media (max-width: ${wideBreakpoints.laptop}) {
        top: 10px;
    }
`;
